import { responsiveListTheme } from 'theme/layout/responsiveList';

export default {
  ArtistPage: {
    width: '100%',
  },
  artistWorks: responsiveListTheme,
};
